import { remCalc } from 'utils/remCalc';

export const overrides = {
	'.longArrowButton__root': {
		'.longArrowButton__link': {
			display: 'flex',
			position: 'relative',
			paddingLeft: remCalc(35),
			paddingRight: remCalc(35),
			transition: 'all var(--transition-duration)',

			'&.longArrowButton__align_left': {
				paddingLeft: 0,
			},

			'.longArrowButton__arrow': {
				transform: 'translateX(20px)',
				right: 0,
				position: 'absolute',
				opacity: 0,
				clipPath: 'inset(0 100% 0 0)',
				transitionTimingFunction: 'var(--transition-timing)',
				transitionProperty: 'opacity, clip-path, transform',
				transitionDuration: 'var(--transition-duration-slow), var(--transition-duration), var(--transition-duration)',
				svg: {
					width: remCalc(55),
				}
			},

			'&:hover': {
				paddingLeft: remCalc(0),
				paddingRight: remCalc(70),
				'.longArrowButton__arrow': {
					transform: 'translateX(0)',
					opacity: 1,
					clipPath: 'inset(0 0 0 0)',
				},
			},
		}
	}
}

const styles = {};

export default styles;